import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import DataGrid from 'react-data-grid'
import Layout from '../../../../brands/components/Layout'
import { Icon } from '@iconify/react'
import { useNavigate } from 'react-router-dom'
import { getTaskList, viewResourceLink } from '../../../viewresources/api/index'
import { useAppDispatch } from '../../../../../redux/hook'
import {
    HIDE_LOADER,
    SHOW_LOADER,
} from '../../../../../redux/slices/LoaderSlice'
import { Row, ItemType } from './types'
import { normalizeLink } from '../../utils'
// import './index.css'
const ViewResource: React.FC = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useAppDispatch()
    const trainingFolderId = location.pathname.substring(
        location.pathname.lastIndexOf('/') + 1
    )
    const queryParams = new URLSearchParams(location.search)
    const program = queryParams.get('program')
    const [rows, setRows] = useState<Row[]>([])

    useEffect(() => {
        const fetchData = async () => {
            dispatch(SHOW_LOADER())
            try {
                const response = await getTaskList(trainingFolderId)
                setRows(
                    response.data.data.map((item: ItemType) => ({
                        title: item.resourceName,
                        category: item.resourceType,
                        score: `${item.marksScored}/${item.passingScore}`,
                        resourceId: item.resourceId,
                        hasQuestionnaire: item.hasQuestionnaire,
                        passingScore: item.passingScore,
                    }))
                )
            } catch (error) {
                console.error(error)
            } finally {
                dispatch(HIDE_LOADER())
            }
        }
        fetchData()
    }, [trainingFolderId])

    const handleViewResource = async (id: string, category: string) => {
        dispatch(SHOW_LOADER())
        try {
            const response = await viewResourceLink(id, 'Resource')
            let resourceLink = response.data
            resourceLink = resourceLink.replace(/\\/g, '/')
            if (['Link', 'link'].includes(category)) {
                // Check if category is 'Link'
                resourceLink = normalizeLink(resourceLink)
            }
            window.open(resourceLink, '_blank')
        } catch (error) {
            console.error(error)
        } finally {
            dispatch(HIDE_LOADER())
        }
    }

    const column = [
        {
            key: 'title',
            name: 'Title',
            resizable: true,
            sortable: true,
            frozen: true,
        },
        {
            key: 'category',
            name: 'Category',
            resizable: true,
            sortable: true,
            frozen: true,
        },
        {
            key: 'score',
            name: 'Score',
            resizable: true,
            sortable: true,
            frozen: true,
        },
        {
            key: 'actions',
            name: 'Actions', // Fix the typo here
            resizable: true,
            renderCell: (props: any) => (
                <>
                    <div className="dropdown-custom-link">
                        {props.row.category === 'pdf' ||
                        props.row.category === 'Document' ? (
                            <Icon
                                icon="material-symbols:download"
                                color="#39877C"
                                style={{ cursor: 'pointer' }}
                                onClick={() =>
                                    handleViewResource(
                                        props.row.resourceId,
                                        props.row.category
                                    )
                                }
                            />
                        ) : props.row.category === 'video' ? (
                            <Icon
                                icon="ph:play-fill"
                                color="#4949C2"
                                onClick={() =>
                                    handleViewResource(
                                        props.row.resourceId,
                                        props.row.category
                                    )
                                }
                                style={{ cursor: 'pointer' }}
                            />
                        ) : props.row.category === 'img' ? (
                            <Icon
                                icon="material-symbols:imagesmode-outline-rounded"
                                color="#4949C2"
                                onClick={() =>
                                    handleViewResource(
                                        props.row.resourceId,
                                        props.row.category
                                    )
                                }
                                style={{ cursor: 'pointer' }}
                            />
                        ) : (
                            <Icon
                                icon="ion:open-outline"
                                color="#39877C"
                                style={{ cursor: 'pointer' }}
                                onClick={() =>
                                    handleViewResource(
                                        props.row.resourceId,
                                        props.row.category
                                    )
                                }
                            />
                        )}
                        {props.row.category !== 'File' &&
                            props.row.hasQuestionnaire && (
                                <div className="ms-4">
                                    <a
                                        className="button button-primary button-align-right"
                                        onClick={() =>
                                            navigate(
                                                `/teacher/resources/questions/${props.row.resourceId}`
                                            )
                                        }
                                    >
                                        TAKE QUESTIONNAIRE
                                    </a>
                                </div>
                            )}
                    </div>
                </>
            ),
        },
    ]

    return (
        <div>
            <Layout>
                <div className="page-information mb-3">
                    <div className="d-flex justify-content-between">
                        <div>
                            <h4>{program}</h4>
                        </div>
                        <div></div>
                    </div>
                </div>
                {rows?.length > 0 ? (
                    <div className="table-wrapper  grid-table-timeoff mt-4">
                        <DataGrid
                            className="data-grid-table"
                            columns={column}
                            rows={rows}
                            rowHeight={60}
                            headerRowHeight={40}
                        />
                    </div>
                ) : (
                    <div className="resources-tasks-norecords">
                        No records found
                    </div>
                )}
            </Layout>
        </div>
    )
}

export default ViewResource
